(() => {
  const dialog = document.getElementById('ILNewsletter');
  const tab = document.querySelector('[data-il-newsletter-open]');
  if (!dialog || !tab || dialog.dataset.initialized) return;
  dialog.dataset.initialized = 'true';
  const key = 'il-newsletter-v1';
  let previousFocus;
  const read = () => { try { return JSON.parse(localStorage.getItem(key) || '{}'); } catch { return {}; } };
  const remember = (data) => { try { localStorage.setItem(key, JSON.stringify(data)); } catch {} };
  const state = read();
  const success = dialog.querySelector('[data-il-signup-success]');
  const errors = dialog.querySelector('[data-il-signup-errors]');
  const blocked = () => document.hidden || document.querySelector('dialog[open], .pv-panel.is-open, .klaviyo-form [role="dialog"], .modal__overlay.is-visible');
  const open = () => { if (dialog.open || typeof dialog.showModal !== 'function') return; previousFocus = document.activeElement; dialog.showModal(); };
  const close = () => { dialog.close(); remember({...read(), dismissedAt:Date.now()}); if(previousFocus?.isConnected) previousFocus.focus(); };
  const preview = new URLSearchParams(location.search).get('newsletter_preview') === '1';
  tab.hidden = !preview;
  tab.addEventListener('click', open);
  dialog.addEventListener('keydown', event => event.stopPropagation());
  dialog.querySelector('.il-newsletter-close').addEventListener('click', close);
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.addEventListener('click', event => { if(event.target !== dialog) return; const r=dialog.getBoundingClientRect(); if(event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom) close(); });
  if(success){ remember({subscribed:true}); tab.hidden=true; open(); return; }
  if(errors){ open(); return; }
  if(preview){open();return;}
  if(state.subscribed || Date.now()-(state.dismissedAt || 0)<7*86400000) return;
  const started=Date.now();
  const timer=setInterval(() => {
    const latest=read();
    if(latest.subscribed || Date.now()-(latest.dismissedAt || 0)<7*86400000){clearInterval(timer);return;}
    if(Date.now()-started>120000){clearInterval(timer);return;}
    if(Date.now()-started<20000 || blocked()) return;
    clearInterval(timer); remember({dismissedAt:Date.now()}); open();
  },1000);
})();
